export const chat1_16 = [
	{
		"user": "bigcock95",
		"message": "schickma bilder…",
		"time": "00:01"
	},
	{
		"user": "{f_model1}",
		"message": "@jan666: ja, ich mag es meine nackten Kurven zu zeigen ;-)",
		"time": "00:02"
	},
	{
		"user": "{f_model2}",
		"message": "boah jungs, ihr seid echt klasse hier, bin schon total geil",
		"time": "00:04"
	},
	{
		"user": "jan666",
		"message": "@{f_model1}: echt jetzt? Wo kann ich dich denn mal heimlich dabei beobachten? *gg*",
		"time": "00:06"
	},
	{
		"user": "{m_model1}",
		"message": "gibt’s hier auch ein paar geile Jungs für Jungs?",
		"time": "00:07"
	},
	{
		"user": "{f_model3}",
		"message": "ich würde ihn zwischen meine großen Titten stecken und dann… ;-)",
		"time": "00:09"
	},
	{
		"user": "Gast2134",
		"message": "Bin ich hier richtig zum Ficken??",
		"time": "00:11"
	},
	{
		"user": "{f_model4}",
		"message": "meinst du sowas bigcock? :-P {ass_pic}",
		"time": "00:14"
	},
	{
		"user": "{f_model1}",
		"message": "@jan666: wenn du dich traust findest du mich hier {profile_link} ;-) aber ich hoffe, du kommst dann auch aus deiner Deckung :-P",
		"time": "00:17"
	},
	{
		"user": "Gast44",
		"message": "@{f_model3}: wie sehen die denn aus? Deine prallen Dinger? Zeig ma!",
		"time": "00:19"
	},
	{
		"user": "candyman",
		"message": "@{f_model3}: ja genau, zeig mal! Mein Schwanz ist da sehr wählerisch :-P",
		"time": "00:21"
	},
	{
		"user": "rolandoman",
		"message": "geiler scheiss hier",
		"time": "00:22"
	},
	{
		"user": "{m_model2}",
		"message": "@{m_model1}: also ich wäre mehr als interessiert *grins*",
		"time": "00:24"
	},
	{
		"user": "jan666",
		"message": "ich eile!!! Bin gleich bei dir Süße! DAS lasse ich mir nicht entgehen. Mal sehen ob du ihn rauslocken kannst *gg*",
		"time": "00:27"
	},
	{
		"user": "{f_model3}",
		"message": "hier habt ihr sie Jungs ;-) {tits_pic}",
		"time": "00:30"
	},
	{
		"user": "Gast4632",
		"message": "kann man hier auch Damen in Action sehen??",
		"time": "00:34"
	},
	{
		"user": "candyman",
		"message": "*sabber* die sind ja echt heiß deine Möpse",
		"time": "00:38"
	},
	{
		"user": "Gast44",
		"message": "aber hallo!!! Dazwischen würde meiner aber mal richtig abgehen :-D",
		"time": "00:39"
	},
	{
		"user": "candyman",
		"message": "@{f_model3}: wie schauts denn mit dem Rest aus :-P",
		"time": "00:42"
	},
	{
		"user": "{f_model1}",
		"message": "Tschüss ihr Süßen, ich muss mich jetzt mal um Jan kümmern ;-) Bis später!",
		"time": "00:45"
	},
	{
		"user": "{f_model2}",
		"message": "@Gast 4632: {profile_pic} wie wärs mit mir süßer? der chat hier hat mich schon richtig in fahrt gebracht, bin schon mitten dabei. also wenn du mir helfen willst *grins*",
		"time": "00:48"
	},
	{
		"user": "{m_model1}",
		"message": "@{m_model2}: okay Süßer, dann lass uns mal ein bisschen privat schreiben",
		"time": "00:50"
	},
	{
		"user": "{f_model4}",
		"message": "@Gast 4632: Du willst Action? :-P So in etwa? {video}",
		"time": "00:52"
	},
	{
		"user": "{f_model3}",
		"message": "@candyman: dir reichen meine boobys nicht? Du bist wohl ein ganz Neugieriger was? ;-) Hmm…nagut ich bin mal nicht so schüchtern :-P {hard_pic}",
		"time": "00:56"
	},
	{
		"user": "{f_model3}",
		"message": "Uuups! Das ist wohl selbst dem Chat hier zu hart *lach* Nur für große Jungs!",
		"time": "01:01"
	},
	{
		"user": "{m_model3}",
		"message": "@{m_model1}: wenn {m_model2} nichts taugt, kannst du auch bei mir vorbeischauen, sitze gerade vor meiner Cam und suche noch jemanden zum spielen ;-)",
		"time": "01:05"
	},
	{
		"user": "{m_model3}",
		"message": "hier findest du mich: {profile_link}",
		"time": "01:07"
	},
	{
		"user": "Gast4632",
		"message": "wow! {f_model4}, hab mich extra mal angemeldet für dein Video, das ist ja MEGA heiß. Das macht mich schon richtig prall in der Hose ;-) Kann man dich auch live sehen???",
		"time": "01:11"
	},
	{
		"user": "candyman",
		"message": "@{f_model3}: ich bin schon ein großer Junge! Und nach deinem Bild auch noch ein ganz harter! *lach* Wo finde ich denn mehr von deiner nackten Schönheit?",
		"time": "01:13"
	},
	{
		"user": "Gast2491",
		"message": "Hey Mädels ich steh voll auf anal. Mein Schwanz will Ärsche sehen!!",
		"time": "01:15"
	},
	{
		"user": "Gast44",
		"message": "@{f_model3}: ich werde von bild zu bild spitzer auf dich! Du musst mir dringend dabei helfen diesen Druck wieder loszuwerden ;-)",
		"time": "01:18"
	},
	{
		"user": "{f_model4}",
		"message": "@Gast4632: na gerne doch! Dan kannst du mir auch gleich sagen, was ich für deinen harten Schwanz so alles gutes tun kann :-D Ich schalte mal meine Cam für dich ein, kommst du? {profile_link}",
		"time": "01:21"
	},
	{
		"user": "{f_model2}",
		"message": "@Gast 2491: Wäre meiner was für deinen arschgeilen Schwanz? {ass_pic}",
		"time": "01:23"
	},
	{
		"user": "Gast 4632",
		"message": "wow! Jetzt hab ich gleich 2 geile Weiber an meiner Angel. Wie soll man(n) sich da bloß entscheiden??? Ich hoffe mein Lümmel hält durch, dann komm ich bei euch beiden  ;-) ;-)",
		"time": "01:26"
	},
	{
		"user": "Gast 4632",
		"message": "Adios Amigos! Hab zu tun :-P :-P",
		"time": "01:28"
	},
	{
		"user": "{f_model3}",
		"message": "@candyman: noch bin ich angezogen ;-) aber wenn du in meine Cam kommst, lasse ich gerne meine Hüllen für dich fallen! :-P {profile_link}",
		"time": "01:32"
	},
	{
		"user": "{f_model3}",
		"message": "für dich natürlich auch '@Gast44. Ich denke mal, wir können auch zu dritt eine Menge Spaß haben *grins*",
		"time": "01:34"
	},
	{
		"user": "Gast2491",
		"message": "@{f_model2}: Na das ist mal ein Prachtarsch! Da geh ich richtig drauf ab. Kannst du mir den mal in Aktion zeigen??",
		"time": "01:38"
	},
	{
		"user": "Gast1132",
		"message": "ICH WILL FICKEN!!! WER MACHT MIT?",
		"time": "01:41"
	},
	{
		"user": "{f_model5}",
		"message": "Huhu! Ist hier jemand, der sich mit mir ein bisschen die Zeit vertreiben möchte? Oder seit ihr alle schon beschäftigt? ;-)",
		"time": "01:45"
	},
	{
		"user": "{f_model5}",
		"message": "bin nämlich ein bisschen einsam",
		"time": "01:47"
	},
	{
		"user": "{f_model5}",
		"message": "ich zeig mich einfach mal {profile_pic}",
		"time": "01:52"
	},
	{
		"user": "{f_model2}",
		"message": "@Gast2491: du meinst wie ich ihn vor deinem harten Lümmel shake und ihn damit anlocke? ;-) Aber gerne doch…mom",
		"time": "01:59"
	},
	{
		"user": "Gast2491",
		"message": "Ja Baby! Zeig ihn mir!!",
		"time": "02:05"
	},
	{
		"user": "Gast1132",
		"message": "ZEIGT EURE ZITZEN MÄDELS!!!",
		"time": "02:10"
	},
	{
		"user": "{f_model2}",
		"message": "Hier kommt mein Knackarsch für dich! ;-D",
		"time": "02:11"
	},
	{
		"user": "{f_model2}",
		"message": "{video}",
		"time": "02:13"
	},
	{
		"user": "caruso",
		"message": "@{f_model5}: bist echt ne total Hübsche! Wie kann so jemand einsam sein??",
		"time": "02:18"
	},
	{
		"user": "{f_model6}",
		"message": "Wo seid ihr, ihr geilen Männer? Ich sitze hier alleine vor meiner Cam und brauch dringend jemand, der mir sagt wos lang geht!!",
		"time": "02:22"
	},
	{
		"user": "{f_model6}",
		"message": "{profile_link}",
		"time": "02:24"
	},
	{
		"user": "{f_model5}",
		"message": "@caruso: tja, weiß auch nicht was mit euch Männern los ist! Dabei mach ich fast alles, was Mann mir sagt :-P",
		"time": "02:28"
	},
	{
		"user": "Gast2491",
		"message": "@{f_model2}: WAHNSINN! Das ist echt das geilste Ding, in das ich meinen besten je reingesteckt habe!!!",
		"time": "02:33"
	},
	{
		"user": "Gast2491",
		"message": "@{f_model2}: Ist da denn auch Platz für was richtig großes? :-P",
		"time": "02:35"
	},
	{
		"user": "caruso",
		"message": "@{f_model5}: darf man mehr von dir sehen?",
		"time": "02:40"
	},
	{
		"user": "the_joymaker",
		"message": "@{f_model6}: Bist also so richtig brav devot? Bin nämlich gerne der Mann im Haus",
		"time": "02:44"
	},
	{
		"user": "{f_model2}",
		"message": "@Gast2491: na aber hallo! Je größer, je besser gefällt es meinem Loch. Dann ist es richtig schön eng für deinen Schwanz. Mhhhh…",
		"time": "02:48"
	},
	{
		"user": "{f_model5}",
		"message": "@caruso: Was würdest du denn gerne sehen? Auf was stehst du? Sowas…?",
		"time": "02:50"
	},
	{
		"user": "{f_model5}",
		"message": "{hard_pic}",
		"time": "02:53"
	},
	{
		"user": "{f_model6}",
		"message": "Dann lass mich deine Sexsklavin sein, joymaker. Ich stehe dir zur Verfügung!",
		"time": "02:58"
	}
]
